// HeroSection.js
import React from 'react';


const ServicesPage = () => (
    <div className="content">
        <h1>Services</h1>
        <p>text goes here</p>
    </div>
);


export default ServicesPage;